<template>
  <div class="flex items-center space-x-4 text-xs">
    <div>
      <icon-base
        v-if="isKnockedOut"
        :icon="IconKnockout"
        :color="UTIL_COLORS.WARNING"
      />
      {{
        $t("SCORECARDS.PTS", {
          points: `${getResultsPoints} ⁄ ${model.scorecard_points}`,
        })
      }}
    </div>
    <div class="grow">
      <scorecard-results-points-bar
        :categories="model.categories"
        :total="model.scorecard_points"
        started
        small
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { type PropType, computed } from "vue";

import { UTIL_COLORS } from "@/helpers/constants";
import { getScorecardIsKnockedOut } from "@/helpers/scorecards";

import IconKnockout from "@/components/icons/IconKnockout.vue";
import ScorecardResultsPointsBar from "@/components/scorecards/ScorecardResultsPointsBar.vue";

import type { ScorecardForGroupTable } from "@/models/scorecards";

const props = defineProps({
  model: {
    type: Object as PropType<ScorecardForGroupTable>,
    required: true,
  },
});

const isKnockedOut = computed(() => getScorecardIsKnockedOut(props.model));

const getResultsPoints = computed(() =>
  isKnockedOut.value ? "" : props.model.points
);
</script>
